const resetForm = (payload) => {
    // payload not needed...
    return {
        type: 'wizard/RESET_FORM',
    }
}

const updateForm = (payload) => {
    return {
        type: 'wizard/UPDATE_FORM',
        payload
    }
};

export { updateForm, resetForm }